import {
  AsYouType,
  parsePhoneNumberFromString,
  type CountryCode,
} from 'libphonenumber-js';

const LOCALE_TO_COUNTRY: Record<string, CountryCode> = {
  en: 'US',
  ro: 'RO',
  de: 'DE',
  es: 'ES',
  fr: 'FR',
};

/** Guess dialing country from app locale (`en` → US, `ro` → RO, …). */
export function phoneCountryFromLocale(locale?: string): CountryCode {
  const base = (locale || 'en').trim().toLowerCase().split('-')[0] ?? 'en';
  return LOCALE_TO_COUNTRY[base] ?? 'US';
}

/** Format as the user types (international-aware). */
export function formatPhoneInput(
  raw: string,
  defaultCountry?: CountryCode
): string {
  return new AsYouType(defaultCountry).input(raw);
}

/** E.164 when valid; otherwise `null`. Empty → `null`. */
export function parseValidPhone(
  raw: string,
  defaultCountry?: CountryCode
): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const parsed = parsePhoneNumberFromString(trimmed, defaultCountry);
  return parsed?.isValid() ? parsed.number : null;
}

/** Non-empty international number check. Empty is not valid. */
export function isValidPhone(
  raw: string,
  defaultCountry?: CountryCode
): boolean {
  return parseValidPhone(raw, defaultCountry) !== null;
}

/** Empty OK; non-empty must be a valid international number. */
export function isPhoneOptionalValid(
  raw: string,
  defaultCountry?: CountryCode
): boolean {
  if (!raw.trim()) return true;
  return isValidPhone(raw, defaultCountry);
}
